import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

export type GetFounderUpdateInboxResponse = {
  emailAddress: string;
};

export function getFounderUpdateInboxErrorMessage(err: unknown): string {
  if (err && typeof err === 'object' && 'message' in err) {
    const message = String((err as { message: string }).message);
    if (message && !message.startsWith('Firebase')) {
      return message;
    }
  }
  if (err && typeof err === 'object' && 'code' in err) {
    const code = String((err as { code: string }).code);
    if (code === 'functions/failed-precondition') {
      return 'Founder update inbox is not configured yet. Contact support if this persists.';
    }
    if (code === 'functions/unauthenticated') {
      return 'Sign in to view your founder update inbox.';
    }
    if (code === 'functions/unavailable') {
      return 'Inbox service is temporarily unavailable. Try again.';
    }
    if (code === 'functions/internal' || code === 'functions/deadline-exceeded') {
      return 'Could not load your inbox address. Try again in a moment.';
    }
  }
  return err instanceof Error ? err.message : 'Could not load your inbox address.';
}

export async function getFounderUpdateInbox(): Promise<GetFounderUpdateInboxResponse> {
  const fn = httpsCallable<void, GetFounderUpdateInboxResponse>(functions, 'getFounderUpdateInbox');
  const result = await fn();
  const emailAddress =
    typeof result.data.emailAddress === 'string' ? result.data.emailAddress.trim() : '';
  if (!emailAddress || !emailAddress.includes('@')) {
    throw new Error('Invalid inbox address returned from server.');
  }
  return { emailAddress };
}
